import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { cornerstoneCtaForCluster } from "@/lib/blog/cornerstoneCta";
import { featureUrlForCluster } from "@/lib/blog/featureRoutes";

interface Props {
  cluster: string | null | undefined;
}

/**
 * Cornerstone CTA rendered on every classified article, between the body
 * (and any AI CTA) and the related-articles strip. Renders nothing when
 * the post's `topic_cluster` is absent or invalid — never inferred.
 */
export function BlogCornerstoneCta({ cluster }: Props) {
  const cta = cornerstoneCtaForCluster(cluster);
  const href = featureUrlForCluster(cluster);
  if (!cta || !href) return null;

  return (
    <aside
      className="my-12 rounded-2xl border border-border bg-card p-6 md:p-8"
      aria-label="Related Youtemp feature"
      data-cornerstone-cluster={cta.cluster}
    >
      <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground mb-2">
        From the product
      </p>
      <h2 className="text-xl md:text-2xl font-heading font-semibold mb-2">
        {cta.heading}
      </h2>
      <p className="text-sm md:text-base text-muted-foreground mb-4">
        {cta.description}
      </p>
      <Link
        to={href}
        className="inline-flex items-center text-sm font-medium text-primary hover:underline"
      >
        {cta.label}
        <ArrowRight className="ml-1 h-4 w-4" />
      </Link>
    </aside>
  );
}